import { meshesOf } from '../../../ft3d/engine/mesh-presentation.js';
import { LIGHT_SOURCE_MESHES } from './light-source-candidates.js';

/** Exact reviewed runtime identities; registry hydration remains the approval gate. */
export function lightSourceRuntimeAsset(runtime: { sha256?: string; url?: string } | undefined) {
  return runtime ? LIGHT_SOURCE_MESHES.find(asset => asset.runtime.sha256 === runtime.sha256 && asset.runtime.url === runtime.url) : undefined;
}

/** A live light radius selects the state within the approved source family. */
export function lightSourceMeshOptions(source: Record<string, any>, radius: unknown): { variant?: string; state?: string } {
  const meshes = meshesOf(source);
  const raw = source.inventory?.mesh_id ?? source.mesh_id;
  const selectedId = String(Array.isArray(raw) ? raw[0] ?? '' : raw ?? '').toUpperCase();
  const selected = selectedId ? meshes.find(mesh => String(mesh.id).toUpperCase() === selectedId) : undefined;
  if (selectedId && (!selected || !lightSourceRuntimeAsset(selected))) return {};
  const candidate = selected ?? meshes.find(mesh => lightSourceRuntimeAsset(mesh));
  if (!candidate) return {};
  const value = Number(Array.isArray(radius) ? radius[0] : radius);
  return { variant: candidate.variant, state: Number.isFinite(value) && Math.abs(value) > 0 ? 'lit' : 'unlit' };
}
